import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, toast } from '@systemeio/ui';
import { COUPONS_API, createCoupon } from 'modules/coupons/api/coupon-api';
import { CouponErrorsInterface, CouponInterface } from 'modules/coupons/types/coupon-interface';
import { AddItemIcon } from 'modules/funnels/funnel/components/offer-settings/add-item-icon';
import AddCouponForm from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/components/add-coupon-form';
import CreateCouponForm from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/components/create-coupon-form';
import { couponDefaultErrors } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/constants/default-error';
import { useAvailableCoupons } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/hooks/use-available-coupons';
import { AddCouponDataInterface, CouponCreateInterface } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/types/add-coupon-data-interface';
import { CouponDefaultErrorsInterface } from 'modules/funnels/funnel/components/step-configuration-tab/coupon-selector/types/default-errors-interface';
import { OfferFormEditType } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-form-interface';
import CouponIcon from 'modules/funnels/funnel/icons/coupon-icon';
import TrashIcon from 'modules/funnels/funnel/icons/trash-icon';
import React, { useRef, useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { fetchWithErrors, fetchWithFieldAndCommonErrors } from 'shared/utils/fetch-with-errors';
const defaultCreateFieldErrors: CouponErrorsInterface = {
  innerName: '',
  code: '',
  discountType: '',
  discountAmount: '',
  currency: '',
  expirationDate: '',
  limitOfUse: ''
};
interface CouponSelectorProps {
  currency: CurrencyEnum;
  data: CouponInterface[];
  onSave: (data: OfferFormEditType['coupons']) => Promise<void>;
}
function CouponSelector(t0) {
  const $ = _c(77);
  const {
    currency,
    data,
    onSave
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const [isAddFormOpen, setIsAddFormOpen] = useState(false);
  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);
  const [createFieldErrors, setCreateFieldErrors] = useState(defaultCreateFieldErrors);
  const [couponErrors, setCouponErrors] = useState(couponDefaultErrors);
  const [couponToDelete, setCouponToDelete] = useState(null);
  const [shouldFetchCoupons, setShouldFetchCoupons] = useState(false);
  let t1;
  if ($[0] !== currency || $[1] !== data || $[2] !== shouldFetchCoupons) {
    t1 = {
      currency,
      shouldFetch: shouldFetchCoupons,
      initialData: data
    };
    $[0] = currency;
    $[1] = data;
    $[2] = shouldFetchCoupons;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    availableCoupons
  } = useAvailableCoupons(t1);
  const createdCouponId = useRef(undefined);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      api: COUPONS_API,
      constantApi: [`${COUPONS_API}/list`]
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const updateData = useUpdateData(t2);
  let closeAddForm;
  let handleAddCoupon;
  let handleCreateCoupon;
  let handleRemoveCoupon;
  let openAddForm;
  let openCreateForm;
  if ($[5] !== availableCoupons || $[6] !== couponToDelete || $[7] !== currency || $[8] !== data || $[9] !== onSave || $[10] !== t || $[11] !== updateData) {
    handleCreateCoupon = async createCouponData => {
      const apiData = {
        ...createCouponData,
        ...(createCouponData.discountType === "fixed" ? {
          currency
        } : {})
      };
      await fetchWithErrors(async () => {
        const response = await createCoupon(apiData);
        await updateData(true, {});
        openAddForm(response.data.id);
      }, setCreateFieldErrors);
    };
    handleAddCoupon = async addCouponData => {
      const fullCoupon = availableCoupons?.find(coupon => coupon.id === addCouponData.couponId);
      if (fullCoupon) {
        await fetchWithFieldAndCommonErrors(async () => {
          const updatedCoupons = data ? [...data, fullCoupon] : [fullCoupon];
          await onSave(updatedCoupons.map(_temp));
          closeAddForm();
          toast.success(t("global.save"));
        }, setCouponErrors);
      }
    };
    let t3;
    if ($[18] !== couponToDelete || $[19] !== data || $[20] !== onSave) {
      t3 = async () => {
        if (couponToDelete) {
          const updatedCoupons_0 = data?.filter(coupon_1 => coupon_1.id !== couponToDelete.id) || [];
          ;
          try {
            await onSave(updatedCoupons_0.map(_temp2));
          } catch (t4) {
            const error = t4;
          }
        }
      };
      $[18] = couponToDelete;
      $[19] = data;
      $[20] = onSave;
      $[21] = t3;
    } else {
      t3 = $[21];
    }
    handleRemoveCoupon = t3;
    let t4;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = () => {
        setIsAddFormOpen(false);
        setIsCreateFormOpen(true);
      };
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    openCreateForm = t4;
    openAddForm = value => {
      setIsAddFormOpen(true);
      setIsCreateFormOpen(false);
      if (value) {
        createdCouponId.current = value;
      }
    };
    closeAddForm = () => {
      setIsAddFormOpen(false);
    };
    $[5] = availableCoupons;
    $[6] = couponToDelete;
    $[7] = currency;
    $[8] = data;
    $[9] = onSave;
    $[10] = t;
    $[11] = updateData;
    $[12] = closeAddForm;
    $[13] = handleAddCoupon;
    $[14] = handleCreateCoupon;
    $[15] = handleRemoveCoupon;
    $[16] = openAddForm;
    $[17] = openCreateForm;
  } else {
    closeAddForm = $[12];
    handleAddCoupon = $[13];
    handleCreateCoupon = $[14];
    handleRemoveCoupon = $[15];
    openAddForm = $[16];
    openCreateForm = $[17];
  }
  let t3;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsCreateFormOpen(false);
    };
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  const closeCreateForm = t3;
  let t4;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CouponIcon />;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== t) {
    t5 = t("dashboard.funnel.configuration.offer.coupons");
    $[25] = t;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== t5) {
    t6 = <div className="text-brand-primary flex flex-row items-center gap-1 text-sm font-normal lg:text-[15px]">{t4}<span>{t5}</span></div>;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== t) {
    t7 = t("dashboard.funnel.configuration.offer.coupons_description");
    $[29] = t;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  let t8;
  if ($[31] !== t7) {
    t8 = <span className="text-sm font-normal">{t7}</span>;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] !== t6 || $[34] !== t8) {
    t9 = <div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3">{t6}{t8}</div>;
    $[33] = t6;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setIsAddFormOpen(true);
      setShouldFetchCoupons(true);
    };
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t) {
    t11 = t("dashboard.funnel.configuration.offer.add_coupon");
    $[37] = t;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== t11) {
    t12 = <AddItemIcon onClick={t10} caption={t11} />;
    $[39] = t11;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== t12 || $[42] !== t9) {
    t13 = <div className="flex flex-col justify-between gap-3 lg:flex-row lg:items-center lg:gap-0">{t9}{t12}</div>;
    $[41] = t12;
    $[42] = t9;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== availableCoupons || $[45] !== closeAddForm || $[46] !== couponErrors || $[47] !== handleAddCoupon || $[48] !== isAddFormOpen || $[49] !== openCreateForm) {
    t14 = isAddFormOpen && <AddCouponForm coupons={availableCoupons} onAddCoupon={handleAddCoupon} openCreateForm={openCreateForm} closeForm={closeAddForm} createdCouponIdRef={createdCouponId} couponFieldErrors={couponErrors} />;
    $[44] = availableCoupons;
    $[45] = closeAddForm;
    $[46] = couponErrors;
    $[47] = handleAddCoupon;
    $[48] = isAddFormOpen;
    $[49] = openCreateForm;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  let t15;
  if ($[51] !== createFieldErrors || $[52] !== handleCreateCoupon || $[53] !== isCreateFormOpen || $[54] !== openAddForm) {
    t15 = isCreateFormOpen && <CreateCouponForm onCreateCoupon={handleCreateCoupon} openAddForm={openAddForm} closeForm={closeCreateForm} createFieldErrors={createFieldErrors} />;
    $[51] = createFieldErrors;
    $[52] = handleCreateCoupon;
    $[53] = isCreateFormOpen;
    $[54] = openAddForm;
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  let t16;
  if ($[56] !== data || $[57] !== t || $[58] !== user?.dateFormat || $[59] !== user?.timeFormat || $[60] !== user?.timezone) {
    t16 = data?.map(coupon_3 => <div className="border-text-secondary/30 relative flex flex-col rounded-lg border p-2 lg:flex-row lg:items-center" key={coupon_3.id}><div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-1 lg:w-1/3"><div className="text-brand-primary flex flex-row items-center gap-1 text-sm lg:text-[15px]"><span>{coupon_3.innerName}</span></div><span className="text-sm lg:text-[15px]">{t("dashboard.coupon.coupon_code")} : {coupon_3.code}</span></div><div className="flex flex-col text-sm lg:w-2/3 lg:flex-row lg:gap-3 lg:text-[15px]"><span>{t("dashboard.funnel.configuration.common.coupon.expiration_date")} :{" "}{coupon_3.expirationDate === null ? t("dashboard.coupon.expiration_date_never") : dateTimeFormat(coupon_3.expirationDate, {
            timeFormat: user?.timeFormat,
            dateFormat: user?.dateFormat,
            timeZone: user?.timezone
          })}</span><span>{t("dashboard.funnel.configuration.common.coupon.limit_of_use_title")} :{" "}{coupon_3.limitOfUse === null ? t("global.unlimited") : t("dashboard.funnel.configuration.common.coupon.limit_of_use", {
            count_used: coupon_3.numberOfUse,
            count_available: coupon_3.limitOfUse
          })}</span></div><TrashIcon className="absolute right-2 top-2 ml-auto h-[18px] w-[17px] cursor-pointer" onClick={() => setCouponToDelete(coupon_3)} /></div>);
    $[56] = data;
    $[57] = t;
    $[58] = user?.dateFormat;
    $[59] = user?.timeFormat;
    $[60] = user?.timezone;
    $[61] = t16;
  } else {
    t16 = $[61];
  }
  let t17;
  if ($[62] !== t13 || $[63] !== t14 || $[64] !== t15 || $[65] !== t16) {
    t17 = <div className="flex flex-col gap-3 px-4 lg:gap-2 lg:px-0">{t13}{t14}{t15}{t16}</div>;
    $[62] = t13;
    $[63] = t14;
    $[64] = t15;
    $[65] = t16;
    $[66] = t17;
  } else {
    t17 = $[66];
  }
  const t18 = !!couponToDelete;
  let t19;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setCouponToDelete(null);
    $[67] = t19;
  } else {
    t19 = $[67];
  }
  let t20;
  if ($[68] !== t) {
    t20 = t("dashboard.funnel.configuration.common.coupon.remove_confirmation");
    $[68] = t;
    $[69] = t20;
  } else {
    t20 = $[69];
  }
  let t21;
  if ($[70] !== handleRemoveCoupon || $[71] !== t18 || $[72] !== t20) {
    t21 = <Confirmation opened={t18} onClose={t19} onConfirm={handleRemoveCoupon} confirmationText={t20} />;
    $[70] = handleRemoveCoupon;
    $[71] = t18;
    $[72] = t20;
    $[73] = t21;
  } else {
    t21 = $[73];
  }
  let t22;
  if ($[74] !== t17 || $[75] !== t21) {
    t22 = <>{t17}{t21}</>;
    $[74] = t17;
    $[75] = t21;
    $[76] = t22;
  } else {
    t22 = $[76];
  }
  return t22;
}
function _temp2(coupon_2) {
  return coupon_2.id;
}
function _temp(coupon_0) {
  return coupon_0.id;
}
export default CouponSelector;